import {
  generateCustomHeadersForTracking,
  generateHeadersByCookieValuesFilterByEqual,
  generateHeadersByCookieValuesFilterByStartsWith,
  generateStatsigHeaderByPageType,
} from '../../common/network/apiUtils';
import {allowedKeysForTolkien, hbAdultCookieKey} from '../../common/network/networkConstants';
import {STATSIG_PAGE_TYPES} from '../../utils/statsig';

import Config from '../../appConfig';

function filterApiFactory(storefrontApiClient) {
  const filterApi = {
    /* Category */
    getFilters(params, cookies) {
      return storefrontApiClient.get('/filterSearch', {
        headers: {
          initialRequest: Boolean(cookies?.initialRequest),
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.CATEGORY),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    getNextFilters(facetId, params, cookies) {
      return storefrontApiClient.get(`/categorySearch/facet/loadmore/${facetId}`, {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.CATEGORY),
        },
        timeout: Config.navigationTimeoutInMilliseconds,
        params,
      });
    },

    /* Search */
    getSearchFilters(params, cookies, headers) {
      return storefrontApiClient.get('/getSearchFilter', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.SEARCH),
          ...headers
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    getSearchNextFilters(facetId, params, cookies) {
      return storefrontApiClient.get(`/productSearch/facet/loadmore/${facetId}`, {
        headers: {
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.SEARCH)
        },
        timeout: Config.navigationTimeoutInMilliseconds,
        params,
      });
    },

    /* Tag */
    getTagFilters(params, cookies) {
      return storefrontApiClient.get('/tagFilter', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.TAG),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    getTagNextFilters(facetId, params, cookies) {
      return storefrontApiClient.get(`/tagSearch/facet/loadmore/${facetId}`, {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.TAG),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    /* Brand */
    getBrandFilters(params, cookies) {
      return storefrontApiClient.get('/brandFilter', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    getBrandNextFilters(facetId, params, cookies) {
      return storefrontApiClient.get(`/brandSearch/facet/loadmore/${facetId}`, {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    getJetDeliveryInfo(params, cookies) {
      return storefrontApiClient.get('/24hourDelivery', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },

    getCampaignFilter(params, cookies) {
      return storefrontApiClient.get('/campaignFilter', {
        headers: {
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },
  };

  return filterApi;
}

export default filterApiFactory;
